import type { FormControlSetting, Setting } from '@/app/editor/iframe/atom/Atom.model';
import { GpElement } from '@/app/editor/iframe/atom/element/GpElement';
import TextareaInfo from '@/app/editor/sidebar/elementsInfo/textarea';

const FormControlSettings: Array<FormControlSetting> = [
  {
    type: 'html:attr',
    name: 'name',
    targetSelector: '.gf_textarea',
    property: 'name',
  },
  {
    type: 'html:attr',
    name: 'required',
    targetSelector: '.gf_textarea',
    property: 'required',
  },
  {
    type: 'html:attr',
    name: 'tf-placeholder',
    targetSelector: '.gf_textarea',
    property: 'placeholder',
  },
  {
    type: 'css',
    name: 'width',
    targetSelector: '.gf_textarea',
    property: 'width',
  },
  {
    type: 'css',
    name: 'height',
    targetSelector: '.gf_textarea',
    property: 'height',
  },
  {
    type: 'css',
    name: 'font-size',
    targetSelector: '.gf_textarea',
    property: 'font-size',
    require: true,
  },
  {
    type: 'css',
    name: 'font',
    targetSelector: '.gf_textarea',
    property: 'font-family',
    require: true,
  },
  {
    type: 'css',
    name: 'text-color',
    targetSelector: '.gf_textarea',
    property: 'color',
    require: true,
  },
  {
    type: 'custom:align',
    name: 'alignment',
    targetSelector: '.elm',
    property: 'align',
  },
  {
    type: 'html:extraClass',
    name: 'extra_class',
    targetSelector: '.elm',
    property: 'data-exc',
  },
];
/**
 * Button Atom Element
 */
export class GpTextarea extends GpElement {
  public $el: JQuery;

  /**
   * [Hook] [override]
   * @param settings ()
   * @returns settings data
   */
  formatSettingAtom(settings: Array<Setting>): Array<Setting> {
    return settings.length > 0 ? settings : TextareaInfo.settings;
  }

  /**
   * [Hook] [override]
   * @returns Name
   */
  getLabel(): string {
    return this.$el.attr('data-label') || TextareaInfo.name;
  }

  /**
   * [Hook] [override]
   * @returns Slug
   */
  getSlug(): string {
    return this.$el.attr('data-slug') || TextareaInfo.slug;
  }

  /**
   * getFormControlSettings;
   * @returns setting read/write from left-sidebar to live page
   */
  getFormControlSettings(): Array<FormControlSetting> {
    return FormControlSettings;
  }
  /**
   * getClassName
   * @returns selector with Class name of element
   */
  getTargetClassSelector(): string {
    return '.' + TextareaInfo.class;
  }
}
